module.exports = "<login-form ng-if=\"!$ctrl.showForgotPassword\" on-forgot-password-clicked=\"$ctrl.onForgotPasswordClicked(email)\" show-password-reset-success-message=\"$ctrl.showPasswordResetSuccessMessage\" init-email=\"$ctrl.initEmail\" message=\"$ctrl.message\"> </login-form> <forgot-password ng-if=\"$ctrl.showForgotPassword\" on-cancel-clicked=\"$ctrl.onCancelForgotPasswordClicked()\" email=\"$ctrl.forgotPasswordEmail\"> </forgot-password> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loginModal/loginModal.html
// module id = 916
// module chunks = 0